import * as Yup from 'yup';

export const riderRemovalsValidationSchema = () =>
  Yup.object().shape({
    removeRider: Yup.array()
      .min(1)
      .of(
        Yup.object().shape({
          riderId: Yup.number().required('Required Field'),
          type: Yup.string().required('Required Field'),
          authorizerDescription: Yup.string().required('Required Field'),
        })
      ),
  });
